/**
 * Configuração da API .NET
 *
 * A URL da API é configurada via VITE_API_BASE_URL:
 * - .env.development → localhost (npm run dev)
 * - .env.production  → api.verboplus.com.br (build/deploy)
 */

const PRODUCTION_HOST = 'https://api.verboplus.com.br'
const productionApiBase = `${PRODUCTION_HOST}/api`

const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:7000/api'
const isApiLocal = /localhost|127\.0\.0\.1/.test(baseURL)
const portalTenantSlug = import.meta.env.VITE_PORTAL_TENANT_SLUG || (import.meta.env.DEV ? 'mang-guarulhos' : '')

// Host da API sem o sufixo /api. É ele quem serve GET /uploads/{**path},
// que responde 302 para a URL pública do arquivo no Cloudflare R2.
const apiHost = baseURL.replace(/\/api\/?$/, '').replace(/\/+$/, '') || PRODUCTION_HOST

const envUploadsBase = (import.meta.env.VITE_UPLOADS_BASE_URL || '').replace(/\/+$/, '')
const envUploadsIsLocal = !!envUploadsBase && /localhost|127\.0\.0\.1/.test(envUploadsBase)
// Em dev com API local não há arquivos no disco: cair para o storage de produção.
const useProductionUploads = import.meta.env.DEV && isApiLocal && (!envUploadsBase || envUploadsIsLocal)

const API_CONFIG = {
  baseURL,
  portalTenantSlug,

  // URL base para imagens/uploads: sempre o host da API (em dev com API local = produção)
  uploadsBaseURL: useProductionUploads ? PRODUCTION_HOST : (envUploadsBase || apiHost),

  // Em dev com API local: buscar galeria e lista de fotos na API de produção (mesmo storage)
  useProductionApiForGallery: import.meta.env.DEV && isApiLocal,
  productionApiBaseURL: productionApiBase,

  timeout: 10000,

  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

if (import.meta.env.DEV) {
  console.log('🔌 API Configurada:', API_CONFIG.baseURL)
  if (API_CONFIG.useProductionApiForGallery) {
    console.log('🔌 Portal: galeria e fotos usam API de produção (storage centralizado)')
  }
}

export default API_CONFIG
